const styles = (theme) => ({
  internationalTransferSelect: {
    backgroundColor: theme.palette.white,
  },
})

export default styles
